var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supsis-plan-card", class: { selected: _vm.isActive } },
    [
      _c(
        "div",
        {
          staticClass: "supsis-plan-card-head",
          class: { popular: _vm.plan.isPopular },
        },
        [
          _c("div", { staticClass: "supsis-plan-card-head-title" }, [
            _c("span", { staticClass: "plan-title" }, [
              _vm._v(_vm._s(_vm.plan.altTitle)),
            ]),
            _vm._v(" "),
            _vm.plan.isPopular
              ? _c("span", { staticClass: "plan-badge" }, [
                  _vm._v(_vm._s(_vm.$t("billing.popular"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isActive
              ? _c("span", { staticClass: "plan-badge" }, [
                  _vm._v(_vm._s(_vm.$t("billing.selectedPlan"))),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "supsis-plan-card-head-pricing" },
            [
              !_vm.plan.isEnterPrise && !_vm.isGroupPlan
                ? [
                    _c(
                      "div",
                      { staticClass: "supsis-plan-card-head-pricing-detail" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.getPerMonthPrice() <= 0
                                ? "Free"
                                : _vm.getPerMonthPrice() + "₺"
                            ) +
                            " "
                        ),
                        _vm.getPerMonthPrice(true) > _vm.getPerMonthPrice()
                          ? _c("span", { staticClass: "discount" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getPerMonthPrice(true)) +
                                  "₺\n                        "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "supsis-plan-card-head-pricing-period" },
                      [
                        _vm.period !== "monthly"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getPrice(
                                      _vm.plan,
                                      _vm.details,
                                      _vm.period
                                    )
                                  ) +
                                  "₺ /"
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getPricePeriod()) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.editableCard
            ? _c(
                "div",
                { staticClass: "supsis-plan-card-head-actions" },
                [
                  _c(
                    "SupsisButton",
                    { attrs: { primary: "" }, on: { click: _vm.editPlan } },
                    [_vm._v(" " + _vm._s(_vm.$t("billing.editPlan")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    { attrs: { danger: "" }, on: { click: _vm.deletePlan } },
                    [_vm._v(_vm._s(_vm.$t("billing.removePlan")))]
                  ),
                  _vm._v(" "),
                  _vm.selfSite
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.visibilityChange },
                        },
                        [
                          _vm.isHidden()
                            ? [_vm._v(" " + _vm._s(_vm.$t("billing.showPlan")))]
                            : [_vm._v(_vm._s(_vm.$t("billing.hiddenPlan")))],
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "supsis-plan-card-head-actions" },
                [
                  _c("CardSelectFeature", {
                    attrs: {
                      plan: _vm.plan,
                      period: _vm.period,
                      "selected-feature-index": _vm.selectedFeatureIndex,
                      "current-plans": _vm.currentPlans,
                    },
                    on: { selectedFeature: _vm.onSelectedFeature },
                  }),
                  _vm._v(" "),
                  _vm.isGroupPlan
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.gotoGroupPlan },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("billing.viewDetails")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm.plan.isEnterPrise
                    ? _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "" },
                          on: { click: _vm.gotoContactSales },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("billing.contactSales")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _c(
                        "SupsisButton",
                        {
                          attrs: {
                            primary: "",
                            disabled:
                              !_vm.isUpgrade && !_vm.isBlockedByResourceLimit,
                          },
                          on: { click: _vm.subscribePlan },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.buttonText) +
                              "\n            "
                          ),
                        ]
                      ),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "supsis-plan-card-body" }, [
        _c("div", { staticClass: "supsis-plan-card-body-content" }, [
          _vm._v(_vm._s(_vm.$t("billing.features"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "supsis-plan-card-body-features" },
          [
            Object.keys(_vm.getOtherFeatures()).length > 0
              ? _vm._l(
                  Object.keys(_vm.getOtherFeatures()),
                  function (key, index) {
                    return _c("CardFeatureText", {
                      key: _vm.getOtherFeatures()[key],
                      attrs: { value: key, features: _vm.getOtherFeatures() },
                    })
                  }
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isGroupPlan
              ? [
                  _c("CardFeatureText", {
                    attrs: { value: "chipPlans", features: _vm.features },
                  }),
                  _vm._v(" "),
                  _c("CardFeatureText", {
                    attrs: { value: "rightToCancel", features: _vm.features },
                  }),
                  _vm._v(" "),
                  _vm.plan.type === "supsis"
                    ? _c("CardFeatureText", {
                        attrs: {
                          value: "stableAgentCount",
                          features: _vm.features,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  [
                    "instagram",
                    "messenger",
                    "whatsapp",
                    "whatsapp-business",
                  ].includes(_vm.plan.type)
                    ? _c("CardFeatureText", {
                        attrs: {
                          value: "stableChannelCount",
                          features: _vm.features,
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._l(
                  Object.keys(_vm.features).slice(
                    0,
                    _vm.moreFeatures
                      ? Object.keys(_vm.features).length +
                          Object.keys(_vm.getOtherFeatures()).length
                      : 5 - Object.keys(_vm.getOtherFeatures()).length
                  ),
                  function (key, index) {
                    return _c("CardFeatureText", {
                      key: key,
                      attrs: { value: key, features: _vm.features },
                    })
                  }
                ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      Object.keys(_vm.features).length > 5
        ? _c(
            "div",
            {
              staticClass: "supsis-plan-card-footer",
              on: { click: _vm.toggleMore },
            },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.moreFeatures ? "arrow_drop_up" : "arrow_drop_down"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _vm.moreFeatures
                ? [_vm._v(" " + _vm._s(_vm.$t("billing.showLess")))]
                : [
                    _vm._v(
                      " +" +
                        _vm._s(Object.keys(_vm.features).length - 5) +
                        " " +
                        _vm._s(_vm.$t("billing.more"))
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PlanLimitWarningModal", {
        attrs: {
          visible: _vm.usageWarningVisible,
          planType: _vm.plan.type,
          isCancel: _vm.isActive,
        },
        on: {
          close: function ($event) {
            _vm.usageWarningVisible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }